import React from 'react'
import { Alert, AlertProps, Button } from '@mui/material'

interface GuidanceErrorDisplayProps {
  error: string
  onRetry?: () => void
}

interface ErrorConfig {
  severity: AlertProps['severity']
  message: string
  showRetry?: boolean
}

const ERROR_CONFIGS: Record<string, ErrorConfig> = {
  服薬指導支援機能が無効です: {
    severity: 'info',
    message: '服薬指導支援機能は現在無効です',
    showRetry: false,
  },
  このリクエストへのアクセス権限がありません: {
    severity: 'warning',
    message: 'このリクエストへのアクセス権限がありません',
    showRetry: false,
  },
  指導支援機能は現在無効です: {
    severity: 'info',
    message: '服薬指導支援機能は現在無効です',
    showRetry: false,
  },
  default: {
    severity: 'error',
    message: '指導支援データの取得に失敗しました',
    showRetry: true,
  },
}

const GuidanceErrorDisplay: React.FC<GuidanceErrorDisplayProps> = ({
  error,
  onRetry,
}) => {
  const config = ERROR_CONFIGS[error] || ERROR_CONFIGS.default

  return (
    <Alert
      severity={config.severity}
      sx={[
        config.severity === 'info'
          ? {
              '& .MuiAlert-message': {
                color: 'text.secondary',
              },
            }
          : {
              '& .MuiAlert-message': {
                color: null,
              },
            },
      ]}
      action={
        config.showRetry && onRetry ? (
          <Button color="inherit" size="small" onClick={onRetry}>
            再取得
          </Button>
        ) : undefined
      }
    >
      {config.message}
    </Alert>
  )
}

export default GuidanceErrorDisplay
